var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDouble = function SvgArrowDouble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11 1.722A.98.98 0 0 0 6.13.337a.98.98 0 0 0-1.385.019L1.236 3.864a.98.98 0 0 0-.018 1.384l3.415 3.415a.98.98 0 0 0 1.384-.018l.078-.087a.976.976 0 0 0-.059-1.298L3.304 4.528 6.11 1.722zm4.654 0a.98.98 0 0 0 .018-1.385.98.98 0 0 0-1.385.019L5.89 3.864a.98.98 0 0 0-.019 1.384l3.415 3.415a.98.98 0 0 0 1.385-.018l.077-.087a.976.976 0 0 0-.059-1.298L7.957 4.528l2.807-2.806z"
  })));
};
export default SvgArrowDouble;